import { FC, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { updatePaperLevels } from "../../../../api/semesterTest.api";
import useAxios from "../../../../hooks/useAxios";
import useNotification from "../../../../hooks/useNotification";
import ErrorResponse from "../../../ErrorResponse";
import Loader from "../../../Loader";
import EditLevel from "./EditLevel";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  scheduleCode: number|undefined;
  examCode: number|undefined;
  doGetSemesterTestPapers: () => void;
  courseCodes: number[]|undefined;
}

const EditLevelModal: FC<IProps> = ({
  visible,
  setVisible,
  scheduleCode,
  examCode,
  doGetSemesterTestPapers,
  courseCodes,
}) => {
  const { t } = useTranslation();
  const { successNotification } = useNotification();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  const [values, setValues] = useState<number[]>([]);

  useEffect(() => {
    if (courseCodes) {
      setValues(courseCodes);
    }
  }, [courseCodes]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      doGetSemesterTestPapers();
      successNotification(t('common.message.save1'));
      setVisible(false);
    }
  }, [submitRes, submitIsLoading]);

  const onClose = () => {
    setValues([]);
    setVisible(false);
  }

  const onSubmit = () => {
    if (!scheduleCode || !examCode) return;
    const req: { courseCode: number }[] = [];
    values.forEach(value => {
      req.push({ courseCode: value });
    });
    submitExecute(updatePaperLevels(scheduleCode, examCode, req));
  }

  return (
    <>
      {submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={submitError} />

      <EditLevel
        visible={visible}
        onClose={onClose}
        onSubmit={onSubmit}
        values={values}
        setValues={setValues}
      />
    </>
  );
}

export default EditLevelModal;
